import { render, staticRenderFns } from "./_rbData2.vue?vue&type=template&id=066b9eeb&scoped=true&lang=pug&"
import script from "./_rbData2.vue?vue&type=script&lang=js&"
export * from "./_rbData2.vue?vue&type=script&lang=js&"
import style0 from "./_rbData2.vue?vue&type=style&index=0&id=066b9eeb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066b9eeb",
  null
  
)

export default component.exports